import React from 'react'
import Product from 'api/models/Product'
import Store from 'api/models/Store'
import ProductModel from '../../../../api/models/Product'
import { CardBody } from 'reactstrap'
import SoldRibbon from '../SoldRibbon/SoldRibbon'
import ProductCount from '../ProductCount/ProductCount'
import { FormattedMessage } from 'react-intl'
import { PoseGroup } from 'react-pose'
import formatPrice from '../../../../helpers/formatPrice'
import {
  CardAddButton,
  CardButtonContainer,
  CardFooter,
  CardFooterContainer,
  CardImage,
  CardImageContainer,
  CardImageCounter,
  CardProductName,
  CardProductPrice,
  CardRemoveButton,
  CardShippableIcon,
  CardStockCounter,
  AnimatedProductCount,
  Card,
  Container
} from './ProductCardStyledComponents'
import { LazyImage } from 'react-lazy-images'
import CardImageLoader from './CardImageLoader'
import Parser from 'html-react-parser'
import debounce from 'lodash/debounce'

interface Props {
  product: ProductModel
  productInCart: ProductModel | undefined,
  isActive: boolean
  index: number,
  test: boolean,
  storeId: string,
  showLowStock: boolean,
  activeStore: Store
  addToCart: (product: Product) => void
  onToggle: (product: Product) => void
  removeFromCart: (product: Product) => void
}

interface State {
  detailsModalOpen: boolean,
  titleWidth: number
}

const formatTitle = (title: string, titleWidth: number) => {
  const splittedTitle = title.split(' ')
  const maxLineLetters = titleWidth / 21
  let lettersCounter = 0
  let firstLine = true
  for (let i = 0; i < splittedTitle.length; i++) {
    if (splittedTitle[i] === '<br/>') {
      continue
    }
    lettersCounter += splittedTitle[i].length
    if (
      lettersCounter >= maxLineLetters &&
      firstLine &&
      i < splittedTitle.length - 1
    ) {
      splittedTitle.splice(i + 1, 0, '<br/>')
      firstLine = false
      lettersCounter = 0
    } else if (!firstLine) {
      break
    }
  }
  return splittedTitle.join(' ')
}

class ProductCard extends React.PureComponent<Props, State> {
  productName: any
  previousCount: number = 0
  previousRandKey: number = -1

  state = {
    detailsModalOpen: false,
    titleWidth: 0
  }

  componentDidMount() {
    this.checkTitleWidth()
    window.addEventListener('resize', debounce(this.checkTitleWidth, 250))
  }

  checkTitleWidth = () => {
    const width = this.productName ? this.productName.clientWidth : 0
    this.setState({ titleWidth: width })
  }

  componentWillUnmount() {
    window.removeEventListener('resize', debounce(this.checkTitleWidth, 250))
  }

  addRemoveButtons = (
    show: boolean,
    addButtonActive: boolean,
  ) => {
    return (
      show && (
        <CardButtonContainer>
          <CardRemoveButton
            show={this.props.productInCart && this.props.productInCart.count}
            onClick={() => this.props.removeFromCart(this.props.product)}
          />
          <CardAddButton
            isactive={addButtonActive}
            onClick={() =>
              addButtonActive && this.props.addToCart(this.props.product)
            }
          />
        </CardButtonContainer>
      )
    )
  }

  toggleModal = () => {
    this.props.isActive &&
      this.setState({ detailsModalOpen: !this.state.detailsModalOpen })
    this.props.onToggle && this.props.onToggle(this.props.product)
  }

  render() {
    const {
      product,
      productInCart,
      index,
      test,
      showLowStock,
      isActive,
      activeStore
    } = this.props
    const showButtons = !product.isSoldOut()
    const addButtonActive =
      !activeStore.isStockEnabled() ||
      !product.isEnabledStock() ||
      !productInCart ||
      (productInCart && product.stock_quantity > productInCart.count)
    // For animation purpose
    const countChanged =
      productInCart && this.previousCount !== productInCart.count
    const randKey = test
      ? -9999
      : countChanged
        ? Math.random()
        : this.previousRandKey
    if (productInCart && productInCart.count) {
      this.previousCount = productInCart.count
    }
    this.previousRandKey = randKey
    // end
    return (
      <Container>
        <Card
          initialPose='hidden'
          pose='visible'
          i={index}
          className='card product'
        >
          <CardBody>
            <CardImageContainer onClick={this.toggleModal}>
              <LazyImage
                src={product.getThumbnail() || ''}
                alt={product.getName()}
                placeholder={({ imageProps, ref }) => (
                  <CardImageLoader
                    innerRef={ref}
                    alt={imageProps.alt}
                  />
                )}
                actual={({ imageProps }) => (
                  <CardImage {...imageProps} />
                )}
              />
            </CardImageContainer>
          </CardBody>
          <CardStockCounter
            show={
              showLowStock &&
              product.isStockLeft() &&
              activeStore.isStockEnabled()
            }
            count={product.getStock()}
          />
          <CardImageCounter
            onClick={this.toggleModal}
            count={product.getImageCount()}
          />
          <CardFooter>
            <CardProductName
              ref={this.productName}
              id='productName'
              title={product.getName()}
            >
              {Parser(formatTitle(product.getName(), this.state.titleWidth))}
            </CardProductName>
            <CardFooterContainer>
              <CardProductPrice isWholesale={product.isWholesale()}>
                {formatPrice(product.getPrice())}
              </CardProductPrice>
              <CardShippableIcon
                show={activeStore.shippingEnabled() && product.isShippable()}
                id={product.getId()}
              />
              <ProductCount {...{ id: product.getId(), show: productInCart && !!productInCart.count }}>
                <PoseGroup>
                  <AnimatedProductCount key={product.getId() + `${randKey}`}>
                    x{productInCart && productInCart.count}
                  </AnimatedProductCount>
                </PoseGroup>
              </ProductCount>
            </CardFooterContainer>
            {isActive && this.addRemoveButtons(showButtons, addButtonActive)}
          </CardFooter>
          <SoldRibbon {...{ show: product.isSoldOut() }}>
            <FormattedMessage id='product.soldOut' />
          </SoldRibbon>
        </Card>
      </Container>
    )
  }
}

export default ProductCard
